<template>
    <div class="resource-booking-box flex-fill border rounded mb-4">
        <div class="content row no-gutters">
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-auto pr-0">
                        <img class="resource-img border border-light p-1 m-2" :src="getImageSrc" />
                    </div>
                    <div class="col pl-0">
                        <div class="m-2">
                            <h5 class="mb-0">{{ resource.name | properCase }}</h5>
                            <h6 class="text-muted mb-3">{{ resource.title ? `Specializzazione in ${resource.title}` : '' }}</h6>
                            <h6>
                                {{ service.name }}{{getAdditionalServicesDescription}}
                                <button type="button"
                                    v-if="hasText(service.description)"
                                    class="btn btn-link text-primary shadow-none service-info-icon p-0 ml-1"
                                    v-on:click="openServiceInfo('description')"
                                    :title="$t('booking.service_description')"
                                    :aria-label="$t('booking.service_description')"
                                    >
                                    <i class="fas fa-info-circle"></i>
                                </button>
                                <button type="button"
                                    v-if="hasText(service.additionalInfo)"
                                    class="btn btn-link text-primary shadow-none service-info-icon p-0 ml-1"
                                    v-on:click="openServiceInfo('preparation')"
                                    :title="$t('booking.preparation_notes')"
                                    :aria-label="$t('booking.preparation_notes')"
                                    >
                                    <i class="fas fa-notes-medical"></i>
                                </button>
                            </h6>
                            <h6 v-html="getPriceRow"></h6>
                            <h6 v-if="!serverSettings.hideServiceDuration">Durata: <span class="font-weight-normal">{{ service.duration }} min</span></h6>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="p-3" style="white-space: pre-wrap;">{{ resource.description }}</div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 border-lg-left">
                <div v-if="presences.length">
                    <div class="row m-2 d-flex flex-row align-content-start">
                        <div class="day-column col-sm px-2 border-top border-sm-0 mb-2"
                            :class="{ 'd-none d-sm-block': !dayPresences.length }"
                            v-for="(dayPresences, date) in paginatedDatesByDay"
                            v-bind:key="date"
                            >
                            <div class="day-column-title clearfix" v-sticky sticky-offset="stickyOptions" sticky-z-index="3">
                                <div class="d-none d-sm-block text-center">{{ date | moment("ddd") | capitalize}}</div>
                                <div class="d-none d-sm-block text-center text-muted">{{ date | moment("DD") }} {{ date | moment("MMM") | capitalize }}</div>

                                <div class="d-sm-none text-center big font-weight-bold pt-2">{{ date | moment("DD")}} {{ date | moment("MMMM") | capitalize }} - {{ date | moment("dddd") | capitalize}}</div>
                            </div>
                            <div class="day-column-availabilities d-flex flex-column">
                                <resource-booking-box-button
                                    class="text-center align-self-start"
                                    v-for="(presence, index) in dayPresences"
                                    v-bind:key="index"
                                    v-bind:headquarterId="presence.headquarterId"
                                    v-bind:startDate="presence.startDate"
                                    v-bind:endDate="presence.endDate"
                                    v-bind:maxSlotDuration="presence.maxSlotDuration"
                                    v-on:book-resource="bookResource"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-if="canBeExpanded" class="text-center p-2 border-top">
                        <button @click="toggleExpansion" class="btn btn-link btn-primary">
                            {{ isExpanded ? $t('booking.show_less_times') : $t('booking.show_more_times') }} <i :class="['fas', isExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                        </button>
                    </div>
                </div>
                <div class="row m-2 d-flex flex-row align-content-start"
                    v-else-if="firstDayPresence"
                    >
                    <resource-booking-box-next-availability-button
                        class="text-center align-self-start col"
                        v-bind:moveToDate="firstDayPresence"
                        v-on:change-date="changeDate"
                    />
                </div>
                <div class="row m-2 d-flex flex-row align-content-start"
                    v-else
                    >
                    <div class="text-center align-self-start col alert alert-danger">Nessuna disponibilità trovata nei prossimi giorni</div>
                </div>
            </div>
        </div>
        <b-modal
            v-model="serviceInfoModalIsOpen"
            :title="serviceInfoTitle"
            modal-class="service-info-modal"
            centered
            scrollable
            ok-only
            :ok-title="$t('booking.close')"
            ok-variant="primary"
            >
            <h6 class="font-weight-bold mb-3">{{ service.name }}</h6>
            <div class="service-info-text">{{ serviceInfoText }}</div>
        </b-modal>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import moment from 'moment';

const VISIBLE_BOOKING_SLOTS_PER_DAY = 5;

export default {
    components: {
    },
    data() {
        return {
            isExpanded: false,
            serviceInfoModalIsOpen: false,
            serviceInfoType: null,
            stickyOptions: {
                top: 84
            }
        };
    },
    props: {
        serverSettings: VueTypes.object,
        instanceId: VueTypes.number.def(undefined),
        resource: VueTypes.object,
        headquarter: VueTypes.object,
        service: VueTypes.object,
        resourceServices: VueTypes.object,
        presences: VueTypes.array,
        firstDayPresence: VueTypes.date,
        filterDate: VueTypes.date,
        filterType: VueTypes.string,
        displayDaysRange: VueTypes.number,
    },
    computed: {
        serviceInfoTitle() {
            return this.serviceInfoType == 'preparation' ? this.$t('booking.preparation_notes') : this.$t('booking.service_description');
        },
        serviceInfoText() {
            return this.serviceInfoType == 'preparation' ? this.service.additionalInfo : this.service.description;
        },
        getImageSrc() {
            return this.resource.imageUrl || defaultProfileImage;
        },
        getAdditionalServicesDescription() {
            let description = "";
            if (this.filterType == "service_category") {
                let countServices = Object.keys(this.resourceServices).length;
                if (countServices > 1) {
                    let additionalServices = countServices - 1;
                    if (additionalServices == 1) {
                        description = " (+" + additionalServices + " altra prestazione disponibile)";
                    } else {
                        description = " (+" + additionalServices + " altre prestazioni disponibili)";
                    }
                }
            }
            return description;
        },
        getDatesByDay() {
            let days = {};
            let currentDay = moment(this.filterDate);
            for (let key = 0; key < this.displayDaysRange; key++) {
                days[currentDay.format("YYYY-MM-DD")] = [];
                currentDay.add(1, 'day');
            }
            for (let key in this.presences) {
                let presence = this.presences[key];
                if (typeof days[moment(presence.startDate).format("YYYY-MM-DD")] == "object") {
                    days[moment(presence.startDate).format("YYYY-MM-DD")].push(presence);
                }
            }

            return days;
        },
        paginatedDatesByDay() {
            if (this.isExpanded) {
                return this.getDatesByDay;
            }

            const paginated = {};
            for (const date in this.getDatesByDay) {
                paginated[date] = this.getDatesByDay[date].slice(0, VISIBLE_BOOKING_SLOTS_PER_DAY);
            }
            return paginated;
        },
        canBeExpanded() {
            for (const date in this.getDatesByDay) {
                if (this.getDatesByDay[date].length > VISIBLE_BOOKING_SLOTS_PER_DAY) {
                    return true;
                }
            }
            return false;
        },
        getPriceRow() {
            let row = "Prezzo: <span class=\"font-weight-normal\">" + this.service.price + "€";
            if (this.service.vatRate > 0) {
                row += " IVA Inc.";
            }
            if (this.service.bookingPrice != this.service.price) {
                row += " (caparra: " + this.service.bookingPrice + "€)";
            } else {
                row += " (pagamento anticipato)";
            }
            row += "</span>";

            return row;
        }
    },
    filters: {
        properCase(string) {
            if (typeof string == "string") {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else {
                return "";
            }
        },
    },
    methods: {
        bookResource(startDate, maxSlotDuration, headquarterId) {
            // this.$emit('setLoadingBookingDialog', true);
            let params = {
                resource: this.resource,
                headquarter: this.headquarter,
                service: this.service,
                resourceServices: this.resourceServices,
                headquarter_id: headquarterId,
                book_date_time: startDate,
                max_slot_duration: maxSlotDuration,
            };
            this.$emit('setBookingPopupData', params);
        },
        changeDate(date) {
            this.$emit('set-date', date);
        },
        toggleExpansion() {
            this.isExpanded = !this.isExpanded;
        },
        hasText(value) {
            return typeof value == "string" && value.trim() !== "";
        },
        openServiceInfo(type) {
            this.serviceInfoType = type;
            this.serviceInfoModalIsOpen = true;
        },
    },
};
</script>

<style lang="scss">
.resource-booking-box {

    .resource-img {
        height: 100px;
        width: 100px;
    }
    .resource-img {
        object-fit: cover;
    }

    .day-column-title.top-sticky {
        background-color: #FFFFFF;
        box-shadow: 0px 6px 4px -5px rgba(0, 0, 0, 0.5);
    }

    .day-column-availabilities {
        margin-top: 5px;

        .btn {
            width: 100%;
            line-height: 0.8em;
        }
    }

    h6 {
        line-height: 1.1em;
        padding-bottom: 0.4em;
    }

    .service-info-icon {
        font-size: 1.2em;
        line-height: 1;
        vertical-align: middle;
    }
    /*
    @media screen and (max-width: 575px) {
        .day-column-title > div {
            display: inline-block;
            font-size: 1.2em
        }
    }
    */
}

.service-info-modal {
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 640px;
        }
    }

    // Il tema (paper-kit) forza display:block sull'header: la X andava a capo sotto il titolo.
    .modal-header {
        display: flex !important;
        align-items: center;
        padding: 0.75rem 1rem;

        &::before,
        &::after {
            content: none;
        }

        .modal-title {
            flex: 1 1 auto;
            margin: 0 0 0 1.5rem;
            font-size: 1.25rem;
            line-height: 1.3;
            text-align: center;
        }

        .close {
            flex: 0 0 1.5rem;
            margin: 0;
            padding: 0;
            line-height: 1;
        }
    }

    .service-info-text {
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        line-height: 1.5;
    }
}
</style>
